import React, { useState } from 'react';
import Select from "./select";
import MovieCard from './MovieCard';
import MovieDetailsModal from './MovieDetailsModal';
import { CITY_OPTIONS } from '../constants';

const DesktopMovieSchedule = ({
                                  selectedDate,
                                  selectedCity,
                                  selectedTimePeriod,
                                  layoutMode,
                                  showSections,
                                  futureMovies,
                                  newReleaseMovies,
                                  topRatedMovies,
                                  classicMovies,
                                  remainingMovies,
                                  dateOptions,
                                  timePeriodOptions,
                                  handleDateChange,
                                  handleCityChange,
                                  handleTimePeriodChange,
                                  toggleLayout,
                                  scrollLeft,
                                  scrollRight,
                                  topRatedScrollRef,
                                  scrollNewReleasesLeft,
                                  scrollNewReleasesRight,
                                  newReleasesScrollRef,
                                  scrollClassicLeft,
                                  scrollClassicRight,
                                  classicScrollRef,
                                  showTooltip,
                                  hideTooltip,
                                  tooltip,
                                  onMovieClick,        // ✅ from parent
                                  onBookingClick,      // ✅ from parent
                                  onShareClick         // ✅ from parent
                              }) => {
    const [selectedMovie, setSelectedMovie] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCardClick = (movie, event) => {
        event.preventDefault();
        event.stopPropagation();

        onMovieClick(movie);   // ✅ parent tracking

        setSelectedMovie(movie);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedMovie(null);
    };

    return (
        <>
            {/* Selectors */}
            <div className="selector-row desktop-selector">
                <div className="date-selector">
                    <Select
                        defaultOption={CITY_OPTIONS.find(city => city.value === selectedCity) || CITY_OPTIONS[0]}
                        options={CITY_OPTIONS}
                        onOptionChange={handleCityChange}
                        className="date-options"
                    />
                </div>
                <div className="date-selector">
                    <Select
                        defaultOption={dateOptions.find(date => date.value === selectedDate) || dateOptions[0]}
                        options={dateOptions}
                        onOptionChange={handleDateChange}
                        className="date-options"
                    />
                </div>
                <div className="date-selector">
                    <Select
                        defaultOption={timePeriodOptions.find(time => time.value === selectedTimePeriod) || timePeriodOptions[0]}
                        options={timePeriodOptions}
                        onOptionChange={handleTimePeriodChange}
                        className="date-options"
                    />
                </div>
                <div className="layout-controls">
                    <button
                        className={`layout-toggle ${layoutMode === 'grid' ? 'active' : ''}`}
                        onClick={toggleLayout}
                        title={layoutMode === 'grid' ? "Switch to List View" : "Switch to Grid View"}
                    >
                        {layoutMode === 'grid' ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 3h4v4H3V3zm6 0h4v4H9V3zm6 0h4v4h-4V3zM3 9h4v4H3V9zm6 0h4v4H9V9zm6 0h4v4h-4V9zM3 15h4v4H3v-4zm6 0h4v4H9v-4zm6 0h4v4h-4v-4z"/>
                            </svg>
                        ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 4h2v2H3V4zm4 0h14v2H7V4zM3 9h2v2H3V9zm4 0h14v2H7V9zm-4 5h2v2H3v-2zm4 0h14v2H7v-2zm-4 5h2v2H3v-2zm4 0h14v2H7v-2z"/>
                            </svg>
                        )}
                    </button>
                </div>
            </div>

            {/* Grid Layout */}
            {layoutMode === 'grid' && (
                <>
                    {newReleaseMovies.length > 0 && (
                        <>
                            <div className="selector-row" data-section="new-releases">
                                <div className="date-selector">New Releases</div>
                            </div>
                            <div className="popular-carousel-container">
                                <button className="carousel-arrow carousel-arrow-left" onClick={scrollNewReleasesLeft}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                                    </svg>
                                </button>
                                <div ref={newReleasesScrollRef} className="popular-movies-scroll">
                                    {newReleaseMovies.map((movie, index) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className={`popular-movie-card ${index === 0 ? "first-movie-card" : ""}`}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <button className="carousel-arrow carousel-arrow-right" onClick={scrollNewReleasesRight}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                                    </svg>
                                </button>
                            </div>
                        </>
                    )}

                    {topRatedMovies.length > 0 && (
                        <>
                            <div className="selector-row" data-section="top-rated">
                                <div className="date-selector">⭐ Top Rated</div>
                            </div>
                            <div className="popular-carousel-container">
                                <button className="carousel-arrow carousel-arrow-left" onClick={scrollLeft}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                                    </svg>
                                </button>
                                <div ref={topRatedScrollRef} className="popular-movies-scroll">
                                    {topRatedMovies.map((movie, index) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className={`popular-movie-card ${index === 0 ? "first-movie-card" : ""}`}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <button className="carousel-arrow carousel-arrow-right" onClick={scrollRight}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                                    </svg>
                                </button>
                            </div>
                        </>
                    )}

                    {classicMovies.length > 0 && (
                        <>
                            <div className="selector-row" data-section="classic">
                                <div className="date-selector">🎬 Classic</div>
                            </div>
                            <div className="popular-carousel-container">
                                <button className="carousel-arrow carousel-arrow-left" onClick={scrollClassicLeft}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                                    </svg>
                                </button>
                                <div ref={classicScrollRef} className="popular-movies-scroll">
                                    {classicMovies.map((movie, index) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className={`popular-movie-card ${index === 0 ? "first-movie-card" : ""}`}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <button className="carousel-arrow carousel-arrow-right" onClick={scrollClassicRight}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                                    </svg>
                                </button>
                            </div>
                        </>
                    )}

                    <div className="selector-row" data-section="all-movies">
                        <div className="date-selector">All Movies</div>
                    </div>

                    <div className="movie-schedule grid-layout desktop-grid">
                        {futureMovies.map((movie) => (
                            <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                <MovieCard
                                    movie={movie}
                                    handleMouseEnter={showTooltip}
                                    handleMouseLeave={hideTooltip}
                                    className=""
                                />
                            </div>
                        ))}
                    </div>
                </>
            )}

            {/* List Layout */}
            {layoutMode === 'list' && (
                <div className="movie-schedule list-layout desktop-list">
                    {futureMovies.map((movie) => (
                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                            <MovieCard
                                movie={movie}
                                handleMouseEnter={showTooltip}
                                handleMouseLeave={hideTooltip}
                                className=""
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* Tooltip */}
            {tooltip.visible && (
                <div className="tooltip" style={{ top: tooltip.top, left: tooltip.left }}>
                    {tooltip.text}
                </div>
            )}

            {/* Movie Modal */}
            <MovieDetailsModal
                movie={selectedMovie}
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onBookingClick={onBookingClick}    // ✅ pass through
                onShareClick={onShareClick}        // ✅ pass through
            />
        </>
    );
};

export default DesktopMovieSchedule;
